import styled from "styled-components";
import Chip from "@mui/material/Chip";
import { alpha } from "@mui/material";
import { TableCellText } from "components/common/Table/styles";

export const InlineContainer = styled("span")`
  display: flex;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const CustomTableCellText = styled(TableCellText)`
  font-size: 0.85rem;
`;

export const CustomTableCellTextWithMargin = styled(TableCellText)`
  font-size: 0.85rem;
  margin-left: 3px;
`;

export const CustomTableCellTextWithIconMargin = styled(TableCellText)`
  font-size: 0.85rem;
  margin-left: 23px;
`;

export const TypographyColoredDanger = styled(TableCellText)`
  color: ${({ theme }) => theme.palette.error.dark};
  font-weight: 450;
  font-size: 0.85rem;
`;

export const TypographyColoredSuccess = styled(TableCellText)`
  color: ${({ theme }) => theme.palette.success.main};
  font-weight: 450;
  font-size: 0.85rem;
`;

export const TypographyColoredWarning = styled(TableCellText)`
  color: ${({ theme }) => theme.palette.warning.main};
  font-weight: 450;
  font-size: 0.85rem;
`;

export const TypographyColored = styled(TableCellText)`
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.secondary.main};
  font-weight: 450;
  font-size: 0.85rem;
`;

export const Tag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.text.primary
      : theme.palette.secondary.dark};
  background: ${({ theme }) =>
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[100]};
`;

export const SuccessTag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.success.dark};
  background: ${({ theme }) => alpha(theme.palette.success.light, 0.1)};
`;

export const DangerTag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.error.dark};
  background: ${({ theme }) => alpha(theme.palette.error.light, 0.1)};
`;

export const WarningTag = styled(Chip)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.warning.dark};
  background: ${({ theme }) => alpha(theme.palette.warning.light, 0.1)};
`;
